module.exports = __webpack_public_path__ + "img/calendar.82197d62.svg";